export default __webpack_public_path__ + "static/media/flag_ru.0c71e16b.svg";